// ====================== MEGANTIC SUBCATEGORIES JS =========================== 
document.addEventListener('DOMContentLoaded', function() {
  if ($('body').hasClass('collection')) {
    var dropdownButton = document.querySelector('.mgc-subcategories-button');
    var dropdownContent = document.querySelector('.mgc-subcategories-dropdown');
    var accordion = document.querySelector('.accordion');
    var panel = document.querySelector('.panel');

    dropdownButton.addEventListener('click', function(event) {
        event.stopPropagation(); 
        dropdownContent.classList.toggle('show');
    });

    window.addEventListener('click', function() {
        if (dropdownContent.classList.contains('show')) {
            dropdownContent.classList.remove('show');
        }
    });

    dropdownContent.addEventListener('click', function(event) {
        event.stopPropagation();
    });

    accordion.addEventListener('click', function() {
        this.classList.toggle('active');
        panel.classList.toggle('show');
    });
  }
});
/** Start Check Ultimate Hex & Xtreme Product **/
 $(document).ready(function(){
   if ($('body').hasClass('product-page')) {
		var currentProductHandle  = $(".product_form").attr("data-product-handle");
		//var lastItem = currentProductHandle.split("-").pop();
		//console.log(currentProductHandle);
		var xtremeHandle = "xtreme-3d-car-mat";
		var ultimateHandle = "hex-ultimate";
        var tintHandle = "window-tint";
        var coatHandle = "shield-car-coating";
		if(currentProductHandle.indexOf(xtremeHandle) != -1){
			var lastItem = currentProductHandle.split("-").slice(-4).join("-");
		}else if(currentProductHandle.indexOf(ultimateHandle) != -1){
			var lastItem = currentProductHandle.split("-").slice(-2).join("-");
        }else if(currentProductHandle.indexOf(tintHandle) != -1){
            var parts = currentProductHandle.split('-');
            var lastItem = parts[parts.length - 3];
        }else if(currentProductHandle.indexOf(coatHandle) != -1){
            var parts = currentProductHandle.split('-');
            var lastItem = parts[parts.length - 4];
		}else{
		  var lastItem = currentProductHandle.split("-").pop();
		}
		//console.log(lastItem);

      var selectProductClassic = currentProductHandle.replaceAll(lastItem, "classic" );
       //var selectProductClassic = currentProductHandle.replace(/classic$/, lastItem);
		 jQuery.getJSON(window.Shopify.routes.root + 'products/' + selectProductClassic + '.js')
			//console.log(product);
            .done(function(product) {
           $('#classic-type').css('visibility','visible');
		  }).fail(function() {
		   $('#classic-type').hide();
           return false;
		  });

     var selectProductEco = currentProductHandle.replaceAll(lastItem, "eco" );
     //var selectProductEco = currentProductHandle.replace(/eco$/, lastItem);
     
		 jQuery.getJSON(window.Shopify.routes.root + 'products/' + selectProductEco + '.js') 
          .done(function(product) {
           $('#eco-type').css('visibility','visible');
		  }).fail(function() {
		   $('#eco-type').hide();
            return false;
		  });

   var selectProductHex = currentProductHandle.replaceAll(lastItem, "hex" );
   //var selectProductHex = currentProductHandle.replace(/hex$/, lastItem);
		 jQuery.getJSON(window.Shopify.routes.root + 'products/' + selectProductHex + '.js')
            .done(function(product) {
			//console.log(product);
           $('#hex-type').css('visibility','visible');
		  }).fail(function() {
		   $('#hex-type').hide();
              return false;
		  });
  
   
		var selectProductXtreme = currentProductHandle.replaceAll(lastItem, "xtreme-3d-car-mat");
		 jQuery.getJSON(window.Shopify.routes.root + 'products/' + selectProductXtreme + '.js')
            .done(function(product) {
			//console.log(product);
           $('#xtreme-type').css('visibility','visible');
		  }).fail(function() {
		   $('#xtreme-type').hide();
              return false;
		  });

	 
		 var selectProductUltimate = currentProductHandle.replaceAll(lastItem, "hex-ultimate" );
     //var selectProductUltimate = currentProductHandle.replace(/hex-ultimate$/, lastItem);
		 jQuery.getJSON(window.Shopify.routes.root + 'products/' + selectProductUltimate + '.js')
                        .done(function(product) {
			//console.log(product);
           $('#ultimatehex-type').css('visibility','visible');
		  }).fail(function() {
		   $('#ultimatehex-type').hide();
                          return false;
		  });

         var selectProductCrystalTint = currentProductHandle.replaceAll(lastItem, "crystal" );
		 jQuery.getJSON(window.Shopify.routes.root + 'products/' + selectProductCrystalTint + '.js')
                        .done(function(product) {
			//console.log(product);
           $('#crystal-type').css('visibility','visible');
		  }).fail(function() {
		   $('#crystal-type').hide();
                          return false;
		  });

         var selectProductDfendTint = currentProductHandle.replaceAll(lastItem, "dfend" );
		 jQuery.getJSON(window.Shopify.routes.root + 'products/' + selectProductDfendTint + '.js') 
                        .done(function(product) {
			//console.log(product);
           $('#dfend-type').css('visibility','visible');
		  }).fail(function() {
		   $('#dfend-type').hide();
                          return false;
		  });

          var selectProductChromaTint = currentProductHandle.replaceAll(lastItem, "chroma" );
		 jQuery.getJSON(window.Shopify.routes.root + 'products/' + selectProductChromaTint + '.js') 
                        .done(function(product) {
			//console.log(product);
           $('#chroma-type').css('visibility','visible');
		  }).fail(function() {
		   $('#chroma-type').hide();
                          return false;
		  });

         var selectProductQuickCoat = currentProductHandle.replaceAll(lastItem, "quik" );
		 jQuery.getJSON(window.Shopify.routes.root + 'products/' + selectProductQuickCoat + '.js') 
                        .done(function(product) {
			//console.log(product);
           $('#quik-type').css('visibility','visible');
		  }).fail(function() {
		   $('#quik-type').hide();
                          return false;
		  });

         var selectProductProCoat = currentProductHandle.replaceAll(lastItem, "pro" );
		 jQuery.getJSON(window.Shopify.routes.root + 'products/' + selectProductProCoat + '.js') 
                        .done(function(product) {
			//console.log(product);
           $('#pro-type').css('visibility','visible');
		  }).fail(function() {
		   $('#pro-type').hide();
                          return false;
		  });

      var selectProductProCoat = currentProductHandle.replaceAll(lastItem, "diamond" );
		 jQuery.getJSON(window.Shopify.routes.root + 'products/' + selectProductProCoat + '.js') 
                        .done(function(product) {
			//console.log(product);
           $('#diamond-type').css('visibility','visible');
		  }).fail(function() {
		   $('#diamond-type').hide();
                          return false;
		  });
   }
   
  });

/** End Check Ultimate Hex & Xtreme Product **/


var $product_img_cell = $(".variant_imgs_cell"), 
    $product_img_cell_array = [],
    $product_slider = $("#productImg").flickity();
	$product_slider.flickity("destroy"),
    $(function() {
      if ($('body').hasClass('product-page')) {
        productImgArray(), imageUpdater();
      }
    }),
    (productImgArray = () => {
        $product_img_cell.each(function() {
            var r = $(this);
            $product_img_cell_array = $product_img_cell_array.concat(r);
        });
    }),
    (getSelectedVariantValue = () => {
        var a = "";
        return (
            $(".swatch_alt_val").each(function() {
                var r = $(this);
                r.prop("checked") && ((r = r.val()), (a += r + "-"));
            }),
            (a = a.replace(/-\s*$/, ""))
        );
    }),
    (imageUpdater = (r) => {
        var t = getSelectedVariantValue(),
        a = 0;
		var radioValue = 'Automatic';
        var altArray = t.split('-');
        var newAltArr = altArray.slice(0, -1); 
        newAltArr.splice(1, 0, radioValue);
        var altStr = newAltArr.toString();
        var t = altStr.replace(/,/g, '-');
      
      var currentProductHandle  = $(".product_form").attr("data-product-handle");
    var lastItem = currentProductHandle.split("-").pop();
     console.log(t);
      console.log(lastItem);
        $product_img_cell.each(function() {
                $(this).remove();
                for (var r = 0; r < $product_img_cell_array.length; r++) {
                    var a = $product_img_cell_array[r].attr("data-title");
                    (t != a && "main_image" != a && "main_image_classic" != a) || $("#productImg .flickity-slider").append($product_img_cell_array[r]);
                }
            });
          if(lastItem == 'eco'){
            $('.swatch-element-type.selected').removeClass('selected');
            (a = r ? 2 : 0);
          }else{
            (a = r ? 1 : 0);
          }
            
            $product_slider.flickity("destroy"),
            $("#productImg").flickity({
                pageDots: !0,
                initialIndex: a
            });
    }),
    (changeSwatch = (r) => {
        $(r);
        setTimeout(function() {
            imageUpdater(!0);
        }, 500);
    }),


  (changeType = (tr) => {
    $('.swatch-element-type.selected').removeClass('selected');
    $(tr).addClass('selected');
    var typeValue = $(tr).attr('data-value'); 
    $("input[value=" + typeValue + "]").attr('checked', 'checked');
    var currentProductHandle  = $(".product_form").attr("data-product-handle");
    var xtremeHandle = "xtreme-3d-car-mat";
	var ultimateHandle = "hex-ultimate";
    var tintHandle = "window-tint";
    var coatHandle = "shield-car-coating";
    if(currentProductHandle.indexOf(xtremeHandle) != -1){
        var lastItem = currentProductHandle.split("-").slice(-4).join("-");
    }else if(currentProductHandle.indexOf(ultimateHandle) != -1){
		var lastItem = currentProductHandle.split("-").slice(-2).join("-");
    }else if(currentProductHandle.indexOf(tintHandle) != -1){
            var parts = currentProductHandle.split('-');
            var lastItem = parts[parts.length - 3];
    }else if(currentProductHandle.indexOf(coatHandle) != -1){
            var parts = currentProductHandle.split('-');
            var lastItem = parts[parts.length - 4];
	}else{
      var lastItem = currentProductHandle.split("-").pop();
    }
    //console.log(lastItem);
    
    if(typeValue == 'Classic'){
      //var selectProductType = currentProductHandle.replaceAll(lastItem, "classic");
      var selectProductType = currentProductHandle.replace(new RegExp(`${lastItem}$`), "classic");
    }
    else if(typeValue == 'Hex'){
      //var selectProductType = currentProductHandle.replaceAll(lastItem, "hex" );
      var selectProductType = currentProductHandle.replace(new RegExp(`${lastItem}$`), "hex");
    }
    else if(typeValue == 'Eco'){
      //var selectProductType = currentProductHandle.replaceAll(lastItem, "eco" );
     
      var selectProductType = currentProductHandle.replace(new RegExp(`${lastItem}$`), "eco");
    }
    else if(typeValue == 'Ultimate-Hex'){
      //var selectProductType = currentProductHandle.replaceAll(lastItem, "hex-ultimate" );
      var selectProductType = currentProductHandle.replace(new RegExp(`${lastItem}$`), "hex-ultimate");
    }
    else if(typeValue == 'Xtreme'){
      var selectProductType = currentProductHandle.replaceAll(lastItem, "xtreme-3d-car-mat" );
    }
    else if(typeValue == 'Crystal'){
      var selectProductType = currentProductHandle.replaceAll(lastItem, "crystal" );
    }
    else if(typeValue == 'Dfend'){
      var selectProductType = currentProductHandle.replaceAll(lastItem, "dfend" );
    }
    else if(typeValue == 'Chroma'){
      var selectProductType = currentProductHandle.replaceAll(lastItem, "chroma" );
    }
    else if(typeValue == 'Quik'){
      var selectProductType = currentProductHandle.replaceAll(lastItem, "quik" );
    }
    else if(typeValue == 'Pro'){
      var selectProductType = currentProductHandle.replaceAll(lastItem, "pro" );
    }
    else if(typeValue == 'Diamond'){
      var selectProductType = currentProductHandle.replaceAll(lastItem, "diamond" );
    }

    window.location.href = "/products/"+selectProductType;
    
    //window.location.href = "/products/"+selectProductType;
    /*var fullProductUrl = "https://my.trapo.asia/products/"+selectProductType;
    $.get( fullProductUrl, function( data ) {
        console.log(data);   
      //var productHtml = data.find(".shopify-section--product-template").html();
       //console.log(productHtml); 
      $(".shopify-section--product-template").empty();
      //console.log($(data).find(".section-wrapper").html());
      $('.shopify-section--product-template').append($(data).find(".shopify-section--product-template").html());
    });
    /*jQuery.getJSON(window.Shopify.routes.root + 'products/' + selectProductType + '.js', function(product) {
      console.log(product);
      var $productImages = product.media;
      console.log($productImages);
      $productImages.forEach(function(item) {
         console.log(item.src);
      });
  
    });*/
  }),

  (changeImage = (tr) => {
    $(tr).addClass('selected');
    $(tr);
        setTimeout(function() {
            imageUpdaterNew(!0);
        }, 500);
  }),
  (imageUpdaterNew = (tr) => {
        var t = getSelectedVariantValue();
    //console.log(t);
        a = 0;
		var radioValue = 'Automatic';
        var altArray = t.split('-');
        var newAltArr = altArray.slice(0, -1); 
        newAltArr.splice(1, 0, radioValue);
        var altStr = newAltArr.toString();;
        var t = altStr.replace(/,/g, '-');
        $product_img_cell.each(function() {
                $(this).remove();
                for (var tr = 0; tr < $product_img_cell_array.length; tr++) {
                    var a = $product_img_cell_array[tr].attr("data-title");
                    (t != a && "main_image" != a && "main_image_classic" != a) || $("#productImg .flickity-slider").append($product_img_cell_array[tr]);
                }
            }),
            (a = tr ? 1 : 0),
          
            $product_slider.flickity("destroy"),
            $("#productImg").flickity({
                pageDots: !0,
                initialIndex: a
            });
    });


$("#back_btn").click(function (){
  window.history.back();
});


 $(document).ready(function(){
      if(window.matchMedia("(max-width: 767px)").matches){
          $('.product-block--title').prependTo('.product__images');
          $('.product-block--price').appendTo('.product-block--title');
          $('.product-block--text').appendTo('.product-block--price');
        $('.price-ui-badges').prependTo('.product-block--title');
      } 
  });

$(window).scroll(function (event) {
    var height = $(window).height();
    var scroll = $(window).scrollTop();
    //console.log(scroll + " " + height);
    if(scroll > height){
     $(".sticky_cart").addClass("show");
    } else {
     $(".sticky_cart").removeClass("show");
    }
});




$(document).ready(function(){
	onload();
	
	//Main Function
	function onload() {
		
		if ($(".modal_price").data('display-campaign')) {
            $('span.savings').remove();
		    var timeonload = setInterval(function() {
				//console.log("onload function calling .....");
				var salePer = $(".modal_price").data('campaign-discount');
				var currentPrice = $('.price .money').text().replace("RM","").replace(",","");
				//console.log(currentPrice);
				clearInterval(timeonload);
				var percentage = currentPrice * salePer / 100;
				var percentage = percentage.toFixed(3);
				var final = currentPrice - percentage;
				var final = final.toFixed(2);
				var final = window.Shopify.formatMoney(final, $('body').data('money-format'));
				
				$(".modal_price").find(".compare-at-price").html($('.price .money').text());
				$(".footer-p-price").find(".was-price").html($('.price .money').text());
				$(".modal_price").find(".price .money").html(final);
				$(".footer-p-price").find(".money").html(final);
				//console.log(final);
                var savingText = "(SAVE "+ salePer +"%)";
                var newElement = $('<span class="savings">'+savingText+'</span>');
                $(".price-ui").after(newElement);
			}, 1000);
		}
	}
	
	// Change price on varient selection - Start 
	if ($(".modal_price").data('display-campaign')) {
        $('span.savings').remove();
		$(document).on("click", ".swatch-element", function() {
			setTimeout(function() {
				//onload();
					var salePer = $(".modal_price").data('campaign-discount');
					var currentPrice = $('.price .money').text().replace("RM","").replace(",","");
					//console.log(currentPrice);
					var percentage = currentPrice * salePer / 100;
					var percentage = percentage.toFixed(3);
					var final = currentPrice - percentage;
					var final = final.toFixed(2);
					var final = window.Shopify.formatMoney(final, $('body').data('money-format'));
					$(".modal_price").find(".compare-at-price").html($('.price .money').text());
					$(".footer-p-price").find(".was-price").html($('.price .money').text());
					$(".modal_price").find(".price .money").html(final);
					$(".footer-p-price").find(".money").html(final);
					//console.log(final);
                    var savingText = "(SAVE "+ salePer +"%)";
                    var newElement = $('<span class="savings">'+savingText+'</span>');
                    $(".price-ui").after(newElement);
			}, 200);
		});
	}
	// Change price on varient selection - End
	
});

 
 /* Promo Bar */
 
 var slides = document.querySelectorAll('#slides .slide');
var currentSlide = 0;
var slideInterval = setInterval(nextSlide,5000);

function nextSlide(){
  slides[currentSlide].className = 'slide';
  currentSlide = (currentSlide+1)%slides.length;
  slides[currentSlide].className = 'slide showing';
}



/** Start Rear Functionality **/
$(document).ready(function(){
  $(document).on("click", ".rear-btn", function() {
      var selBrand = $("#r-brand option:selected").val();
      var selModel = $("#r-model option:selected").val();
      var selYear = $("#r-year option:selected").val();

      if (selBrand == "" || selModel == "" || selYear == "") {
          //If the "Please Select" option is selected display error.
          alert("Please select an option!");
          return false;
      }

      if(selBrand != '' || selYear != '' || selModel != '' ){
        //console.log(selBrand);
        //console.log(selModel);
        //console.log(selYear);
        var rearProductHandle = selBrand + '-' + selModel + '-' + selYear + '-rear-trapo-classic';
        
        rearProductHandle = rearProductHandle.replace(/[\. ,:-]+/g, "-");
        
          jQuery.getJSON(window.Shopify.routes.root + 'products/' + rearProductHandle.replace(/\s+/g, "-") + '.js', function(product) {
			window.location.href = "/products/"+rearProductHandle.replace(/\s+/g, "-").toLowerCase();
		  }).fail(function() {
		   alert('Product not found!!')
		  });
      }
  });
});


$('#r-brand').on('change', function() {
  $('#r-model').prop('selectedIndex',0);
  $('#r-year').prop('selectedIndex',0);
  $("#r-year option").not(':first').hide();
  $("#r-model span").contents().unwrap();
  $("#r-year option").not(':first').addClass('dn');
  var selBrand = this.value;
  $('#r-model option').each(function(i) {
    if(i > 0){
      var optionBrand = $(this).data("brand");
      if(optionBrand == selBrand){
        $(this).show();
        $(this).removeClass('dn');
      }else{
        $(this).hide();
        $(this).addClass('dn');
      }
    }
  });
  $('.dn').wrap('<span>');
});

$('#r-model').on('change', function() {
  $('#r-year').prop('selectedIndex',0);
  var selModel = this.value;
  var selBrand = $('#r-brand').find(":selected").val();
  $("#r-year span").contents().unwrap();
  $('#r-year option').each(function(i) {
    if(i > 0){
      var optionBrand = $(this).data("brand");
      var optionModel = $(this).data("model");
      if(optionBrand == selBrand && optionModel == selModel ){
        $(this).show();
        $(this).removeClass('dn');
      }else{
        $(this).hide();
        $(this).addClass('dn');
      }
    }
  });
  $('.dn').wrap('<span>');
});

/** End Rear Functionality **/


/** Start Dashcam Filter Functionality **/

$(document).ready(function(){
  $(document).on("click", ".dashcam-btn", function() {
      var selDashModel = $("#dash-model option:selected").val();
  
      if (selDashModel == "" ) {
          //If the "Please Select" option is selected display error.
          alert("Please select an option!");
          return false;
      }

      if(selDashModel != '' ){
      
        var dashProductHandle = selDashModel ;
        //console.log(dashProductHandle);
        if(dashProductHandle == 'trapo-i-sight-t350-dashcam'){
          var variantId = 40156459302989;
        }
        if(dashProductHandle == 'trapo-i-sight-t550-dashcam'){
          var variantId = 40157387849805;
        }
        
          jQuery.getJSON(window.Shopify.routes.root + 'products/' + dashProductHandle.replace(/\s+/g, "-") + '.js', function(product) {
			//window.location.href = "/products/"+rearProductHandle.replace(/\s+/g, "-").toLowerCase();
            var params = {
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {id: variantId,quantity: '1'},
                  dataType: 'json',
                  success: function(line_item) {
                    window.location.href = "/checkout/";
                  },
                };
                $.ajax(params);
		  }).fail(function() {
		   alert('Product not found!!')
		  });
      }
  });
  $(document).on("click", ".scroll-btm-btn", function() {
    $('html, body').animate({
        scrollTop: $("#r-form").offset().top
    }, 50);
  });
});

/** End Dashcam Filter Functionality **/



/** Start Wiper Filter Functionality **/
$(document).ready(function(){
  $(document).on("click", ".wiper-btn", function() {
      var selWiperBrand = $("#w-brand option:selected").val();
      var selWiperModel = $("#w-model option:selected").val();
      var selWiperYear = $("#w-year option:selected").val();

      if (selWiperBrand == "" || selWiperModel == "" || selWiperYear == "") {
          //If the "Please Select" option is selected display error.
          alert("Please select an option!");
          return false;
      }

      if(selWiperBrand != '' || selWiperYear != '' || selWiperModel != '' ){
        //console.log(selWiperBrand);
        //console.log(selWiperModel);
        //console.log(selWiperYear);
        var wiperProductHandle = selWiperBrand + '-' + selWiperModel + '-' + selWiperYear + '-hydrophobic-wiper-blade';
        //console.log(wiperProductHandle);
        wiperProductHandle = wiperProductHandle.replace(/[\. ,:-]+/g, "-");
        
          jQuery.getJSON(window.Shopify.routes.root + 'products/' + wiperProductHandle.replace(/\s+/g, "-") + '.js', function(product) {
            //console.log(product);
			//console.log(product.variants[0].id);
            var params = {
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {id: product.variants[0].id,quantity: '1'},
                  dataType: 'json',
                  success: function(line_item) {
                    window.location.href = "/checkout/";
                  },
                };
                $.ajax(params);
		  }).fail(function() {
		   alert('Product not found!!')
		  });
      }
  });
});


$('#w-brand').on('change', function() {
  $('#w-model').prop('selectedIndex',0);
  $('#w-year').prop('selectedIndex',0);
  $("#w-year option").not(':first').hide();
  $("#w-model span").contents().unwrap();
  $("#w-year option").not(':first').addClass('dn');
  var selWiperBrand = this.value;
  $('#w-model option').each(function(i) {
    if(i > 0){
      var optionBrand = $(this).data("brand");
      if(optionBrand == selWiperBrand){
        $(this).show();
        $(this).removeClass('dn');
      }else{
        $(this).hide();
        $(this).addClass('dn');
      }
    }
  });
  $('.dn').wrap('<span>');
});

$('#w-model').on('change', function() {
  $('#w-year').prop('selectedIndex',0);
  var selWiperModel = this.value;
  var selWiperBrand = $('#w-brand').find(":selected").val();
  $("#w-year span").contents().unwrap();
  $('#w-year option').each(function(i) {
    if(i > 0){
      var optionBrand = $(this).data("brand");
      var optionModel = $(this).data("model");
      if(optionBrand == selWiperBrand && optionModel == selWiperModel ){
        $(this).show();
        $(this).removeClass('dn');
      }else{
        $(this).hide();
        $(this).addClass('dn');
      }
    }
  });
  $('.dn').wrap('<span>');
});

/** End Wiper Filter Functionality **/


/** Start Car Size Functionality **/
$(document).ready(function(){
  $(document).on("click", ".size-btn", function() {
      var selBrand = $("#s-brand option:selected").val();
      var selModel = $("#s-model option:selected").val();
      var selYear = $("#s-year option:selected").val();

      if (selBrand == "" || selModel == "" || selYear == "") {
          //If the "Please Select" option is selected display error.
          alert("Please select an option!");
          return false;
      }

      if(selBrand != '' || selYear != '' || selModel != '' ){
        //console.log(selBrand);
        //console.log(selModel);
        //console.log(selYear);
        var rearProductHandle = selBrand + '-' + selModel + '-' + selYear + '-trapo-classic';
        rearProductHandle = rearProductHandle.replace(/[\. ,:-]+/g, "-").toLowerCase();  
        console.log(rearProductHandle);
          jQuery.getJSON(window.Shopify.routes.root + 'products/' + rearProductHandle.replace(/\s+/g, "-") + '.js', function(product) {
			//window.location.href = "/products/"+rearProductHandle.replace(/\s+/g, "-").toLowerCase();
            //console.log(product.tags);
            $.each(product.tags, function(index, value) {
              //console.log(value);
              var str2 = "size";
              if(value.indexOf(str2) != -1){
                //console.log(value);
                  var carSize = value.replace('size:','');
                  alert(carSize);
              }
              
            });
		  }).fail(function() {
		   alert('Product not found!!')
		  });
      }
  });
});


$('#s-brand').on('change', function() {
  $('#s-model').prop('selectedIndex',0);
  $('#s-year').prop('selectedIndex',0);
  $("#s-year option").not(':first').hide();
  $("#s-model span").contents().unwrap();
  $("#s-year option").not(':first').addClass('dn');
  var selBrand = this.value;
  $('#s-model option').each(function(i) {
    if(i > 0){
      var optionBrand = $(this).data("brand");
      if(optionBrand == selBrand){
        $(this).show();
        $(this).removeClass('dn');
      }else{
        $(this).hide();
        $(this).addClass('dn');
      }
    }
  });
  $('.dn').wrap('<span>');
});

$('#s-model').on('change', function() {
  $('#s-year').prop('selectedIndex',0);
  var selModel = this.value;
  var selBrand = $('#s-brand').find(":selected").val();
  $("#s-year span").contents().unwrap();
  $('#s-year option').each(function(i) {
    if(i > 0){
      var optionBrand = $(this).data("brand");
      var optionModel = $(this).data("model");
      if(optionBrand == selBrand && optionModel == selModel ){
        $(this).show();
        $(this).removeClass('dn');
      }else{
        $(this).hide();
        $(this).addClass('dn');
      }
    }
  });
  $('.dn').wrap('<span>');
});

$("#s-brand option").each(function() {
  $(this).siblings('[value="'+ this.value +'"]').remove();
});
$("#s-model option").each(function() {
  $(this).siblings('[value="'+ this.value +'"]').remove();
});
$("#s-year option").each(function() {
  $(this).siblings('[value="'+ this.value +'"]').remove();
});

$(".search-submit").click(function() {
        $(".search_form").submit();
    });

/** End Car Size Functionality **/


jQuery(document).ready(function() {
        // Toggle modal visibility
        jQuery('.modal-toggle').on('click', function(e) {
            e.preventDefault();
            jQuery('.offer-modal').toggleClass('is-visible');
            jQuery('body').toggleClass('modal-open');
        });

        // Close modal when clicking on the close button
        jQuery('.close').on('click', function() {
            jQuery('.offer-modal').removeClass('is-visible');
            jQuery('body').removeClass('modal-open');
        });

        // Close modal when clicking outside of it
        jQuery(document).on('click', function(e) {
            if (jQuery('.offer-modal').hasClass('is-visible') && !jQuery(e.target).closest('.offer-modal').length && !jQuery(e.target).closest('.modal-toggle').length) {
                jQuery('.offer-modal').removeClass('is-visible');
                jQuery('body').removeClass('modal-open');
            }
        });
  $(" .dropdown_toggle").on("click", function() {
        $(this)
            .parent("  .submenu_item")
            .children(" .submenu_list ")
            .stop()
            .slideToggle();
    });
    });


  $(".scroll-tc").click(function() {
    $('html, body').animate({
        scrollTop: $(".why_buy").offset().top
    }, 2000);
});


$('.add-to-cart').click(function() {
                // Trigger click event on button2
                $('.ajax-submit').click();
            });

            $('.search-open').click(function() {
             $('.searchbar form input').trigger('click');
    });


/** Start Refresh Package Functionality **/

$(document).ready(function(){

  $(document).on("click", ".refresh-submit", function() {
      var selBrand = $("#car-brand option:selected").val().toLowerCase().replace(/\s+/g, '-').replace(/[()]/g, '');
      var selModel = $("#car-model option:selected").val().toLowerCase().replace(/\s+/g, '-').replace(/[()]/g, '');
      var selYear = $("#car-year option:selected").val().toLowerCase().replace(/\s+/g, '-').replace(/[()]/g, '');

     var selBase = getSelectedRadioValue('option-0');
    var selLining = getSelectedRadioValue('option-1'); 
    $('.refresh-error').empty();
    
      if (selBrand == "" || selModel == "" || selYear == "") {
          //If the "Please Select" option is selected display error.
          alert("Please select an option!");
          return false;
      }
    // console.log(selBrand);
    //     console.log(selModel);
    //     console.log(selYear);
    // console.log(selBase);
    // console.log(selLining);

      if(selBrand != '' || selYear != '' || selModel != '' ){
        
        var classicProductHandle = selBrand + '-' + selModel + '-' + selYear + '-trapo-classic';
        var wiperProductHandle = selBrand + '-' + selModel + '-' + selYear + '-hydrophobic-wiper-blade';
        
        classicProductHandle = classicProductHandle.replace(/[\. ,:-]+/g, "-");
        wiperProductHandle = wiperProductHandle.replace(/[\. ,:-]+/g, "-");

        //console.log(classicProductHandle.replace(/\s+/g, "-"));
        //console.log(wiperProductHandle.replace(/\s+/g, "-"));

        jQuery.getJSON(window.Shopify.routes.root + 'products/' + classicProductHandle.replace(/\s+/g, "-") + '.js', function(matproduct) {
			//window.location.href = "/products/"+rearProductHandle.replace(/\s+/g, "-").toLowerCase();
            console.log(matproduct);

          var matSize = $('#car-mat-size').val();
          //console.log(matSize);
          if(matSize == 'Small' || matSize == 'Medium' || matSize == 'Large' || matSize == '3 Rows' ){
            var option3 = "Front + Rear";
          }else if(matSize == 'Small MPV' || matSize == 'Large MPV'){
            var option3 = "All Included";
          }
            
            var option1 = selBase; 
            var option2 = selLining; 
             
            const variantMatId = getVariantIdByOptions(matproduct, option1, option2, option3);
            //console.log(variantMatId); 
            if(variantMatId){
              $.ajax({
                  type: "POST",
                  dataType: 'json',
                  url: '/cart/add.js',
                  data: {
                      quantity: 1,
                      id: variantMatId
                  },
                  async: false
              });
            }else{
              alert('For this package, available for Front and Rear only.');
            }
            
		  }).fail(function() {
		   alert('Car Mat Product not found!!')
		  });

        jQuery.getJSON(window.Shopify.routes.root + 'products/' + wiperProductHandle.replace(/\s+/g, "-") + '.js', function(wiperproduct) {
			//window.location.href = "/products/"+rearProductHandle.replace(/\s+/g, "-").toLowerCase();
            //console.log(wiperproduct);
            const variantFrontWiperId = wiperproduct.variants.find(variant => variant.title === "Front").id;   
            
            if(variantFrontWiperId){
                $.ajax({
                    type: "POST",
                    dataType: 'json',
                    url: '/cart/add.js',
                    data: {
                        quantity: 1,
                        id: variantFrontWiperId
                    },
                    async: false
                });
              }
		  }).fail(function() {
		   alert('Only available for cars with compatible wipers.');
            //$('.refresh-error').text('NOTE: The refresh package is not available for this car model.');
            return false;
		  });
 
          jQuery.getJSON(window.Shopify.routes.root + 'products/refresh-trapo-quik-shield-car-coating.js', function(quickcoat) {
			//window.location.href = "/products/"+rearProductHandle.replace(/\s+/g, "-").toLowerCase();
            var sizeCode = $('#car-size').val();
            //console.log(sizeCode);
            //console.log(quickcoat);
            if(sizeCode == 'undefined') {
              var sizeCode = 'S';
            }
            const coatId = getVariantIdByTitle(quickcoat,sizeCode);
            //console.log(coatId);

            if(coatId){
              $.ajax({
                  type: "POST",
                  dataType: 'json',
                  url: '/cart/add.js',
                  data: {
                      quantity: 1,
                      id: coatId
                  },
                  async: false
              });
            }
      
		  }).fail(function() {
		  
		  });

        jQuery.getJSON(window.Shopify.routes.root + 'products/refresh-watermark-removal-glass-coating-service.js', function(watermark) {
			//window.location.href = "/products/"+rearProductHandle.replace(/\s+/g, "-").toLowerCase();
            //console.log(watermark);
            var sizeCode = $('#car-size').val();
          //console.log(sizeCode);
          if( sizeCode == 'undefined') {
              var sizeCode = 'S';
            }
            const watermarkId = getVariantIdByTitle(watermark,sizeCode);
            //console.log(watermarkId);

            if(watermarkId){
              $.ajax({
                  type: "POST",
                  dataType: 'json',
                  url: '/cart/add.js',
                  data: {
                      quantity: 1,
                      id: watermarkId
                  },
                  async: false
              });
            }
      
		  }).fail(function() {
		  
		  });
  
      }
  });

  function getSelectedRadioValue(name) {
    const radios = document.getElementsByName(name);
    for (const radio of radios) {
        if (radio.checked) {
            return radio.value;
        }
    }
    return null; // Return null if no radio is selected
  }

  function getVariantIdByOptions(product, option1, option2, option3) {
      // Construct the variant title by joining the options with a slash
      const variantTitle = `${option1} / ${option2} / ${option3}`;
      
      // Loop through the variants array
      for (let variant of product.variants) {
          // Check if the variant title matches the constructed title
          if (variant.title === variantTitle) {
              return variant.id; // Return the variant ID if found
          }
      }
      return null; // Return null if no matching variant is found
  }

  function getVariantIdByTitle(product, title) {
    const variant = product.variants.find(variant => variant.title === title);
    return variant ? variant.id : null;
}

// Function to get size based on brand, model, and year
function getSize(brand, model, year) {
    return fetchCarSizeData() // Fetch the data
        .then(data => {
            // Check if the brand exists
            if (data.brands[brand]) {          
                if (data.brands[brand].models[model]) {         
                    // Check if the year exists
                    const years = data.brands[brand].models[model].years;
                    for (const yearRange in years) {
                        if (yearRange.includes(year)) {
                            return years[yearRange]; // Return the size
                        }
                    }
                } else {
                    console.log(`Model not found: ${model}`); // Log if model is not found
                }
            } else {
                console.log(`Brand not found: ${brand}`); // Log if brand is not found
            }
            return null; // Return null if not found
        })
        .catch(error => {
            console.error("Error in getSize function:", error);
            return null; // Return null in case of error
        });
}

// Fetching car size data from the URL
function fetchCarSizeData() {
    const jsonUrl = "https://trapo.com/search-car-category/filtered_car_tags.json";
    return fetch(jsonUrl)
        .then(response => {
            // Check if the response is OK (status in the range 200-299)
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json(); // Parse the JSON data
        })
        .catch(error => {
            console.error("Error fetching data:", error);
            throw error; // Rethrow the error to be handled in getSize
        });
}

});

/** End Refresh Package Functionality **/



/** Start CNY Refresh Package Functionality **/

$(document).ready(function(){
  
  $(document).on("click", ".cny-refresh-submit", function() {
      var selBrand = $("#car-brand option:selected").val().toLowerCase().replace(/\s+/g, '-').replace(/[()]/g, '');
      var selModel = $("#car-model option:selected").val().toLowerCase().replace(/\s+/g, '-').replace(/[()]/g, '');
      var selYear = $("#car-year option:selected").val().toLowerCase().replace(/\s+/g, '-').replace(/[()]/g, '');

     var selScented = getSelectedRadioValue('option-0'); 
    $('.refresh-error').empty();
    
      if (selBrand == "" || selModel == "" || selYear == "") {
          //If the "Please Select" option is selected display error.
          alert("Please select an option!");
          return false;
      }
    // console.log(selBrand);
    //     console.log(selModel);
    //     console.log(selYear);
    // console.log(selBase);
    // console.log(selLining);

      if(selBrand != '' || selYear != '' || selModel != '' ){
        
        var wiperProductHandle = selBrand + '-' + selModel + '-' + selYear + '-hydrophobic-wiper-blade';
        wiperProductHandle = wiperProductHandle.replace(/[\. ,:-]+/g, "-");

        //console.log(classicProductHandle.replace(/\s+/g, "-"));
        //console.log(wiperProductHandle.replace(/\s+/g, "-"));

        jQuery.getJSON(window.Shopify.routes.root + 'products/trapo-starter-kit.js', function(scentproduct) {
			//window.location.href = "/products/"+rearProductHandle.replace(/\s+/g, "-").toLowerCase();
            console.log(scentproduct);
  
            var option1 = selScented;
             
            const variantScentId = getVariantIdByOption(scentproduct, option1);
            console.log(variantScentId); 
            if(variantScentId){
              $.ajax({
                  type: "POST",
                  dataType: 'json',
                  url: '/cart/add.js',
                  data: {
                      quantity: 1,
                      id: variantScentId
                  },
                  async: false
              });
            }else{
            }
            
		  }).fail(function() {
		   alert('Car Scent Product not found!!')
		  });

        jQuery.getJSON(window.Shopify.routes.root + 'products/' + wiperProductHandle.replace(/\s+/g, "-") + '.js', function(wiperproduct) {
			//window.location.href = "/products/"+rearProductHandle.replace(/\s+/g, "-").toLowerCase();
            //console.log(wiperproduct);
            const variantFrontWiperId = wiperproduct.variants.find(variant => variant.title === "Front").id;   
            
            if(variantFrontWiperId){
                $.ajax({
                    type: "POST",
                    dataType: 'json',
                    url: '/cart/add.js',
                    data: {
                        quantity: 1,
                        id: variantFrontWiperId
                    },
                    async: false
                });
              }
		  }).fail(function() {
		   alert('Only available for cars with compatible wipers.');
            //$('.refresh-error').text('NOTE: The refresh package is not available for this car model.');
            return false;
		  });
 
      jQuery.getJSON(window.Shopify.routes.root + 'products/refresh-trapo-quik-shield-car-coating.js', function(quickcoat) {
			//window.location.href = "/products/"+rearProductHandle.replace(/\s+/g, "-").toLowerCase();
            var sizeCode = $('#car-size').val();
            //console.log(sizeCode);
            //console.log(quickcoat);
            if(sizeCode == 'undefined') {
              var sizeCode = 'S';
            }
            const coatId = getVariantIdByTitle(quickcoat,sizeCode);
            //console.log(coatId);

            if(coatId){
              $.ajax({
                  type: "POST",
                  dataType: 'json',
                  url: '/cart/add.js',
                  data: {
                      quantity: 1,
                      id: coatId
                  },
                  async: false
              });
            }
      
		  }).fail(function() {
		  
		  });

      jQuery.getJSON(window.Shopify.routes.root + 'products/refresh-watermark-removal-glass-coating-service.js', function(watermark) {
			//window.location.href = "/products/"+rearProductHandle.replace(/\s+/g, "-").toLowerCase();
            //console.log(watermark);
            var sizeCode = $('#car-size').val();
          //console.log(sizeCode);
          if( sizeCode == 'undefined') {
              var sizeCode = 'S';
            }
            const watermarkId = getVariantIdByTitle(watermark,sizeCode);
            //console.log(watermarkId);

            if(watermarkId){
              $.ajax({
                  type: "POST",
                  dataType: 'json',
                  url: '/cart/add.js',
                  data: {
                      quantity: 1,
                      id: watermarkId
                  },
                  async: false
              });
            }
      
		  }).fail(function() {
		  
		  });

      jQuery.getJSON(window.Shopify.routes.root + 'products/premium-foldable-magsafe-car-phone-holder.js', function(phoneholder) {
			//window.location.href = "/products/"+rearProductHandle.replace(/\s+/g, "-").toLowerCase();
            console.log(phoneholder);
            const variantPhoneholderId = phoneholder.variants.find(variant => variant.title === "Default Title").id;
            
            if(variantPhoneholderId){
              $.ajax({
                  type: "POST",
                  dataType: 'json',
                  url: '/cart/add.js',
                  data: {
                      quantity: 1,
                      id: variantPhoneholderId
                  },
                  async: false
              });
            }
      
		  }).fail(function() {
		  
		  });
  
      }
  });

  function getSelectedRadioValue(name) {
    const radios = document.getElementsByName(name);
    for (const radio of radios) {
        if (radio.checked) {
            return radio.value;
        }
    }
    return null; // Return null if no radio is selected
  }

  function getVariantIdByOption(product, option1) {
      // Construct the variant title by joining the options with a slash
      const variantTitle = `${option1}`;
      
      // Loop through the variants array
      for (let variant of product.variants) {
          // Check if the variant title matches the constructed title
          if (variant.title === variantTitle) {
              return variant.id; // Return the variant ID if found
          }
      }
      return null; // Return null if no matching variant is found
  }

  function getVariantIdByTitle(product, title) {
    const variant = product.variants.find(variant => variant.title === title);
    return variant ? variant.id : null;
}

// Function to get size based on brand, model, and year
function getSize(brand, model, year) {
    return fetchCarSizeData() // Fetch the data
        .then(data => {
            // Check if the brand exists
            if (data.brands[brand]) {          
                if (data.brands[brand].models[model]) {         
                    // Check if the year exists
                    const years = data.brands[brand].models[model].years;
                    for (const yearRange in years) {
                        if (yearRange.includes(year)) {
                            return years[yearRange]; // Return the size
                        }
                    }
                } else {
                    console.log(`Model not found: ${model}`); // Log if model is not found
                }
            } else {
                console.log(`Brand not found: ${brand}`); // Log if brand is not found
            }
            return null; // Return null if not found
        })
        .catch(error => {
            console.error("Error in getSize function:", error);
            return null; // Return null in case of error
        });
}

// Fetching car size data from the URL
function fetchCarSizeData() {
    const jsonUrl = "https://trapo.com/search-car-category/filtered_car_tags.json";
    return fetch(jsonUrl)
        .then(response => {
            // Check if the response is OK (status in the range 200-299)
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json(); // Parse the JSON data
        })
        .catch(error => {
            console.error("Error fetching data:", error);
            throw error; // Rethrow the error to be handled in getSize
        });
}

});

/** End CNY Refresh Package Functionality **/


$(document).ready(function() {
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('s') === 'refer-friend') {
        var $section = $('#refer-friend');
        if ($section.length) {
            var offset = $section.offset().top - 100; // 100px above the section
            if (offset < 0) offset = 0; // Prevent negative scroll
            $('html, body').animate({
                scrollTop: offset
            }, 500);
        }
    }
});





